// Single render-condition for the menu editor's "Needs review" button.
// Kept as a pure function so the non-Square gating matrix is unit-testable.
const canShowNeedsReviewButton = ({ integrated, canView, count }) =>
  !!integrated && !!canView && count > 0;

export default canShowNeedsReviewButton;
